import test from './components/test';
import { headerSrcoll, headerToggle, headerSubmenu } from './components/header';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    headerSrcoll();
    headerToggle();
    headerSubmenu();
  },
  false
);
